import { defineComponent as _defineComponent } from 'vue'
import { Store, StoreType } from '@/typings/user';
import { BDropdown } from 'bootstrap-vue';
import { Ref, computed, onBeforeMount, ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'StoreSelector',
  props: {
    title: { default: 'Switch stores to browse through your different subscriptions' },
    stores: { default: () => [] },
    includeNoBilling: { type: Boolean, default: false },
    noStoresText: { default: '' },
    value: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'input', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { title: string, stores: Store[], includeNoBilling: boolean, noStoresText: string, value?: string };





const storeUrl = ref('');
const storesDropdownRef: Ref<BDropdown | null> = ref(null);

const filteredStores = computed(() =>
    props.stores.filter((s) => (props.includeNoBilling ? true : s.HasBilling || s.Type === StoreType.Shopify))
);

watch(
    () => props.stores,
    () => {
        storeUrl.value = filteredStores.value.length ? filteredStores.value[0].Url : '';
    }
);

watch(
    () => props.value,
    () => {
        storeUrl.value = props.value || '';
    }
);

onBeforeMount(() => {
    if (filteredStores.value.length) {
        setStoreUrl(filteredStores.value[0].Url);
    }
});

const setStoreUrl = (store: string) => {
    if (storeUrl.value !== store) {
        storeUrl.value = store;
        emit('input', store);
    }
};

const onStoresDropdownClick = () => {
    storesDropdownRef.value?.show();
};

return { __sfc: true,emit, props, storeUrl, storesDropdownRef, filteredStores, setStoreUrl, onStoresDropdownClick, BDropdown }
}

})